import type { Product } from '@/domain/Product.ts';
import * as ProductService from '@/widgets/services/ProductService.ts';
import * as ContentService from '@/widgets/services/ContentService.ts';
import * as MarketService from '@/widgets/services/MarketService.ts';
import * as SubscriptionService from '@/widgets/services/SubscriptionService.ts';
import {
  resolveWidgetConfig,
  type WidgetConfig
} from '@/domain/WidgetConfig.ts';
import type { PDPRoute } from '@/domain/Route.ts';
import type { Market } from '@/domain/Market.ts';
import type { StaticContent } from '@/widgets/hooks/useStaticContent.tsx';
import isPreview from '@/widgets/utils/isPreview.ts';

export async function getRemoteData(route: PDPRoute): Promise<{
  marketConfig: Market;
  product?: Product;
  config: WidgetConfig;
  staticContent: StaticContent;
}> {
  const withCacheBusting = isPreview();
  const marketConfig = await MarketService.getMarketUsingNAPI();
  const [product, config, aboutSubscriptions] = await Promise.all([
    ProductService.getProduct(
      route.market,
      route.channel,
      route.productType,
      route.locale,
      route.slug,
      withCacheBusting
    ),
    ContentService.getProductDetailsHeroConfig(
      route.market,
      route.channel,
      route.locale,
      withCacheBusting
    ),
    SubscriptionService.getAboutSubscriptions(
      route.market,
      route.channel,
      route.locale,
      withCacheBusting
    )
  ]);

  return {
    marketConfig,
    product,
    config: resolveWidgetConfig(config, route.technology, route.productType),
    staticContent: {
      aboutSubscriptions
    }
  };
}
